<div class="d-flex">
  <label class="switch">
    <input type="checkbox" (change)="valueChanged($event)" [checked]="selected">
    <span class="toggle round"></span>
  </label>
</div>